<template>
    <div id="customerAddModal" class="modal fade add-customer-popup" ref="customerAddModal">
        <div class="modal-dialog modal-confirm modal-dialog-scrollable" style="max-width: 1140px;">
            <div class="modal-content">
                <div class="modal-header p-3 bg-soft-info">
                    <div class="icon-box">

                    </div>
                    <h4 class="modal-title">Create Warehouse</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true"><i  class="ri-close-line"></i></button>
                </div>
                <div class="modal-body">
                    <div class="add-customer-section">

                        <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
                            <form @submit.prevent="handleSubmit(save)" id="addCustomerForm" name="addCustomerForm" method="post">
                                <div class="new-rfq">
                                    <div class="row">
                                        <div class="alert alert-success succ_msg" v-if="successMessage !=null">
                                            <strong class="success_msg">{{successMessage}}</strong>
                                        </div>
                                        <div v-if="commonErrors.length !=0" class="alert alert-danger alert-dismissible">
                                            <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                                            <ul>
                                                <li v-for="(v, k) in commonErrors" :key="k">
                                                    <p v-for="error in v" :key="error" class="text-sm">
                                                        {{ error }}
                                                    </p>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="col-lg-12 col-md-12">
                                            <div class="panel create-box border mb-3">

                                                <div class="card-body">
                                                    <h2 class="mb-3 inner-title">Information</h2>
                                                    <div class="row">
                                                        <div class="col-lg-3 col-md-6 ">
                                                            <div class="form-group flex-fill">
                                                                <validation-provider rules="required" v-slot="{ errors }">
                                                                    <label>Name</label>
                                                                    <input type="text" class="form-control" name="company_name" placeholder="" v-model="form.name">
                                                                    <span class="error">{{ errors[0] }}</span>
                                                                </validation-provider>
                                                            </div>
                                                        </div>
                                                        <!-- <div class="col-lg-3 col-md-6 ">
                                                            <div class="form-group flex-fill">
                                                                <label>Description</label>
                                                                <input type="text" class="form-control" placeholder="" name="website" id="website" v-model="form.description" />
                                                            </div>
                                                        </div> -->
                                                        <div class="col-lg-3 col-md-6 ">
                                                            
                                                            <div class="form-group flex-fill">
                                                                <!-- <label>Address</label> -->
                                                                <GooglePlaceAutoComplete v-if="loadMap"
                                                                :title="'Address'"
                                                                :placeholder="'Address'"
                                                                :errors="null"
                                                                v-model="form.address"
                                                                @selectedEvent="selectCompanyAddress"></GooglePlaceAutoComplete>
                                                                <!-- <input type="text" class="form-control" 
                                                                       name="address" placeholder="Company Address" v-model="form.address"> -->
                                                            </div>
                                                        </div>

                                                        <div class="col-lg-3 col-md-6 ">
                            
                                                            <div class="form-group flex-fill">
                                                                <label>Address 2</label>
                                                                <input type="text" class="form-control" 
                                                                       name="address" placeholder="Company Address" v-model="form.address2">
                                                            </div>
                                                        </div>

                                                        <div class="col-lg-3 col-md-6 ">
                                                            <div class="form-group flex-fill">
                                                                <label>Country</label>
                                                                <validation-provider rules="required" v-slot="{ errors }">
                                                                    <select class="form-control" id="country_id1" name="country_id" v-model="form.country_id">
                                                                        <option value="null">Select Country</option>
                                                                        <option v-for="country in countries" :value="country.id">{{country.name}}</option>
                                                                    </select>
                                                                    <span class="error">{{ errors[0] }}</span>
                                                                </validation-provider>
                                                            </div>
                                                        </div>
                                                        
                                                        
                                                        <div class="col-lg-3 col-md-6 ">
                                                            <div class="form-group flex-fill">
                                                                <label>City</label>
                                                                <input type="text" class="form-control" placeholder="" name="fax" id="phone" v-model="form.city" />
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-3 col-md-6 ">
                                                            <div class="form-group flex-fill">
                                                                <label>Post Code</label>
                                                                <input type="text" class="form-control" placeholder="" name="email" id="email" v-model="form.post_code" />
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-3 col-md-6 ">
                                                            <div class="form-group flex-fill">
                                                                <label>State</label>
                                                                <input type="text" class="form-control" placeholder="" name="email" id="email" v-model="form.state" />
                                                            </div>
                                                        </div>
                                                       
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            
                                            <!--  Billing Contact ends here -->
                                            <!-- Shipping Adress -->

                                            

                                            <!-- Shipping Adress -->

                                        

                                        </div>
                                    </div>

                                    <div class="btnrow text-right">
                                        <button type="button" class="btn btn-danger" data-dismiss="modal" aria-hidden="true">Cancel</button>
                                        <!-- <router-link :to="{name: 'viewCustomers'}" class="btn skip-btn">Discard</router-link> -->
                                        <button type="submit" class="btn custom-btn ml-1" id="save_customer_btn">Save</button>
                                        <!-- <a href="#" class="btn custom-btn ml-3">Save</a> -->
                                    </div>
                                </div>
                            </form>
                        </ValidationObserver>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ValidationObserver,ValidationProvider, extend,validate  } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";
import GooglePlaceAutoComplete from "./GooglePlaceAutoComplete";

Object.keys(rules).forEach(rule => {
    extend(rule, rules[rule]);
});

// with typescript
for (let [rule, validation] of Object.entries(rules)) {
    extend(rule, {
        ...validation
    });
}
export default {
    name: "CustomerAdd",
    components: {
        ValidationProvider,ValidationObserver,
        GooglePlaceAutoComplete,
    },
    props: [ 'bus'],
    created() {
        /*this.getCountries();
        this.getSalesRep();
        this.setSuccessMessage(null);*/
    },
    mounted() {
        let self = this;
        this.loadMap = true;
        console.log("loadMap",this.loadMap)
        $(this.$refs.customerAddModal).on('show.bs.modal', () => {
            self.isModalOpen = true;
            self.getCountries();
            //self.getSalesRep();
            self.getContactTypes();
            self.setSuccessMessage(null);
        });

        $(this.$refs.customerAddModal).on('hide.bs.modal', () => {
            self.isModalOpen = false;
        });
    },
    data(){
        return {
            loadMap:false,
            isModalOpen: false,
            countries: [],
            salesRep: {
                data:[]
            },
            contactTypes: [],
            form: {
                id: null,
                name: null,
                description: null,
                address: null,
                address2: null,
                city: null,
                post_code: null,
                state: null,
                country_id: null,
                
                
            },
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setCustomers',
            'setCustomerLoading'
        ]),
        selectCompanyAddress(place){
            let country = place.address_components.find((x) => x.types.includes('country'));

            if(country) {
                let selectedCountry = this.countries.find((x) => x.code === country.short_name);
                if(selectedCountry) {
                    this.form.country_id = selectedCountry.id;
                }
            }

            // if(place.name != '') {
            //     this.form.address = place.name+' , '+place.formatted_address;
            // }
            // else{
            //     this.form.address = place.formatted_address;
            // }


            let lat = place.geometry.location.lat();
            let lng = place.geometry.location.lng();
            let neighborhood = place.address_components.find((x) => x.types.includes('neighborhood'));
            let sublocality = place.address_components.find((x) => x.types.includes('sublocality'));
            let locality = place.address_components.find((x) => x.types.includes('locality'));
            let pinCode = place.address_components.find((x) => x.types.includes('postal_code'));
            let state = place.address_components.find((x) => x.types.includes('administrative_area_level_1'));
            let city = place.address_components.find((x) => x.types.includes('administrative_area_level_3'));
            //let country = place.address_components.find((x) => x.types.includes('country'));
            //console.log("locality",locality);
            let address = '';
            if(neighborhood) {
                address += neighborhood.long_name;
            }
            if(sublocality) {
                address += address.length > 0 ?', ' : '';
                address += sublocality.long_name;
            }
            if(locality) {
                address += address.length > 0 ?', ' : '';
                address += locality.long_name;
            }

            if(address == '') {
                address = place.formatted_address;
            }

            if(place.name != '') {
                if(!this.form.address2 || this.form.address2 === ''){
                   // this.form.shipping[index].address2 = place.name;
                }
                //this.form.shipping[index].address = place.name+' , '+place.formatted_address;
                //alert("place.name"+place.name);
                this.form.address = place.name;
            }
            else{
                
                //this.form.shipping[index].address = place.formatted_address;
                this.form.address = address;
            }

            this.form.post_code = null;
            if(pinCode) {
                this.form.post_code = pinCode.long_name;
            }
            this.form.city = null;

            
            if(neighborhood) {
                console.log("city",neighborhood);
                this.form.city = neighborhood.long_name;
               // console.log("this.form.shipping[index].city",this.form.shipping[index].city);
            }
            if(!neighborhood && locality) {
                console.log("city",locality);
                this.form.city = locality.long_name;
               // console.log("this.form.shipping[index].city",this.form.shipping[index].city);
            }
            if(!neighborhood &&  !locality && city) {
                console.log("city",locality);
                this.form.city = city.long_name;
                //console.log("this.form.shipping[index].city",this.form.shipping[index].city);
            }
            
            this.form.state = null;
            if(state) {
                this.form.state = state.short_name;
            }

        },
        selectShippingAddress(place, index){
            let lat = place.geometry.location.lat();
            let lng = place.geometry.location.lng();
            let pinCode = place.address_components.find((x) => x.types.includes('postal_code'));
            let neighborhood = place.address_components.find((x) => x.types.includes('neighborhood'));
            let sublocality = place.address_components.find((x) => x.types.includes('sublocality'));
            let locality = place.address_components.find((x) => x.types.includes('locality'));
            let state = place.address_components.find((x) => x.types.includes('administrative_area_level_1'));
            let city = place.address_components.find((x) => x.types.includes('administrative_area_level_3'));
            let country = place.address_components.find((x) => x.types.includes('country'));

            //console.log(place)
            let address = '';
            if(neighborhood) {
                address += neighborhood.long_name;
            }
            if(sublocality) {
                address += address.length > 0 ?', ' : '';
                address += sublocality.long_name;
            }
            if(locality) {
                address += address.length > 0 ?', ' : '';
                address += locality.long_name;
            }

            if(address == '') {
                address = place.formatted_address;
            }


            if(place.name != '') {
                if(!this.form.shipping[index].location || this.form.shipping[index].location === ''){
                    this.form.shipping[index].location = place.name;
                }
                //this.form.shipping[index].address = place.name+' , '+place.formatted_address;
                this.form.shipping[index].address = address;
            }
            else{
                //this.form.shipping[index].address = place.formatted_address;
                this.form.shipping[index].address = address;
            }

            this.form.shipping[index].zip = null;
            if(pinCode) {
                this.form.shipping[index].zip = pinCode.long_name;
            }
            this.form.shipping[index].city = null;
            if(!locality && city) {
                this.form.shipping[index].city = city.long_name;
            }
            this.form.shipping[index].state = null;
            if(state) {
                this.form.shipping[index].state = state.long_name;
            }

        },
        onContactTypeSelect(event, index){
            console.log(event)
            this.form.contacts[index].contact_type_ids = [];
            if (event) {
                event.forEach((x) => {
                    this.form.contacts[index].contact_type_ids.push(x.id);
                })
            }
        },
        onContactTypeDeSelect(event, index){
            console.log(event)
            this.form.contacts[index].contact_type_ids = [];
            if (event) {
                event.forEach((x) => {
                    this.form.contacts[index].contact_type_ids.push(x.id);
                })
            }
        },
        save() {

            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(window.route('store-warehouse.store'), this.form,{
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                        //console.log("Errors ",this.commonErrors);
                        for(var i = 0;i< this.commonErrors.length;i++){
                            //console.log("Errors inside ");
                        }
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.customerData = data.data;
                        self.$emit('customerDataSaved', data.data);


                        self.setSuccessMessage("Warehouse added successfully.");
                        this.reset();
                        setTimeout(() => {

                            $('#customerAddModal').modal('hide');
                            self.setSuccessMessage(null);
                        }, 3500);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
        
       
       
      
       
        async reset() {
            this.form =  {
                id: null,
                customer_so_note:null,
                purchase_terms:null,
                customer_payment_terms:null,
                stocking_terms:null,
                company_name: null,
                address: null,
                country_id: null,
                website: null,
                fax: null,
                sales_rep_id:'',
                phone:null,
                email:null,
                contacts: [
                    {
                        contact_id: null,
                        contact_name: null,
                        contact_email: null,
                        status: 1,
                        default_contact:true,
                        contact_role:null,
                        contact_type_id: 1,
                        contact_type_ids:[1],
                        contact_types: [],
                        contact_numbers: [
                            {
                                contact_phn_type: 'Mobile',
                                contact_phone_no: null,
                            }
                        ]
                    }
                ],
                shipping:[
                    {
                        location:null,
                        address:null,
                        state:null,
                        city:null,
                        zip:null,
                        default_contact:true
                    }
                ],
                billing:[
                    {
                        contact_id: null,
                        contact_name: null,
                        contact_email: null,
                        status:null,
                        default_contact:true,
                        contact_type_id:null,
                        contact_type_ids:[1],
                        contact_role:null,
                        contact_numbers: [
                            {
                                contact_phn_type: 'Mobile',
                                contact_phone_no: null,
                            }
                        ]
                    }
                ],
                about_us: null,
                status: 1,
            };
            requestAnimationFrame(() => {
                this.$refs.observer.reset();
            });
        },
        getCountries() {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('countries.index'), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.countries = data.data.countries;

                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
        getSalesRep() {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('sales-reps.index'), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.salesRep = data.data.saleUsers;

                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
        getContactTypes() {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('getContactTypes'), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors && data.errors.length){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.contactTypes = data.data;

                        let firstTypes = this.contactTypes.filter((x) => x.id == 1);

                        this.form.contacts.forEach((contact) => {
                            contact.contact_types = firstTypes;
                        })
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);
                })
                .finally(() => {
                    self.setCustomerLoading(false);
                });
        },
    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'customers',
            'customersLoading'
        ])
    }
}
</script>

<style scoped>
.vs__selected {
    z-index: 3 !important;
}
.modal-dialog .vs__selected-options .vs__search {
    width: 0px !important;
}
</style>
